<template>
  <div class="sectionThirdParty" id="thirdParty" ref="thirdPartyRef">
    <div
      class="char"
      ref="charRef"
      :class="{ active: !isSupported || targetIsVisible }"
    ></div>
    <div class="social-bg">
      <FbFans
        class="social-content"
        :fanSrc="thirdParty.iframe.link"
        :appId="thirdParty.iframe.appId"
        v-if="thirdParty.iframe.type === 'facebook'"
      ></FbFans>
    </div>
    <div class="social-btn" @click="clickBtnUpload">
      <a
          v-for="(item, index) in thirdParty.supportArr"
          :key="index"
          :href="item.link"
          :data-type="item.type"
          :class=item.type
          data-reason="thirdParty"
          target="_blank"
      ></a>
    </div>
  </div>
</template>
<script setup lang="ts">
import FbFans from '@/components/thirdParty/FbFans.vue';
import thirdPartyHook from '@/hooks/thirdPartyHook';
import { clickBtnUpload } from '@/utils/pointUtils';
// FB配置
const { charRef, targetIsVisible, isSupported, thirdParty } = thirdPartyHook();
</script>
